export const BACKEND_URL = "https://bharatagrotech-backend.onrender.com";
// export const BACKEND_URL = "http://localhost:8080";

export const navigation = [
  { name: "Home ", href: "/" },
  { name: "Products", href: "/product" },
  { name: "About Us ", href: "/about" },
  { name: "Contact", href: "/contact" },
  { name: "Testimonials", href: "/testimonial" },
];
